"use client"

import { Switch } from "@headlessui/react"

import { Text } from "@/components/ui/text"

interface ToggleProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label?: string
  ariaLabel?: string
  disabled?: boolean
}

export const Toggle = ({ checked, onChange, label, ariaLabel, disabled }: ToggleProps) => (
  <Text as="label" variant="body" family="text" tone="default" className="inline-flex cursor-pointer items-center gap-250 has-disabled:cursor-not-allowed">
    <Switch
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      aria-label={ariaLabel}
      className="hit-target group bg-line data-checked:bg-brand focus-visible:ring-brand relative h-6.5 w-12.75 shrink-0 rounded-full transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50"
    >
      <span className="bg-surface absolute top-0.5 left-0.5 inline-block size-5.5 rounded-full shadow-sm transition-transform group-data-checked:translate-x-6.25" aria-hidden />
    </Switch>
    {label && <span>{label}</span>}
  </Text>
)
